const BUILD_METADATA_URL = "/harday-build.json";
const BUILD_ID_STORAGE_KEY = "hardayFrontendBuildId";
let refreshInProgress = false;

const isSafeReloadPath = () => {
  const path = window.location.pathname || "/";
  return !path.startsWith("/api/") && !path.startsWith("/downloads/");
};

const clearBrowserManagedCaches = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    } catch (error) {
      console.warn("Harday build refresh: service worker cleanup skipped", error);
    }
  }

  if (window.caches?.keys) {
    try {
      const names = await window.caches.keys();
      await Promise.all(names.map((name) => window.caches.delete(name)));
    } catch (error) {
      console.warn("Harday build refresh: Cache Storage cleanup skipped", error);
    }
  }
};

const fetchBuildMetadata = async () => {
  const response = await fetch(`${BUILD_METADATA_URL}?t=${Date.now()}`, {
    cache: "no-store",
    headers: { "Cache-Control": "no-cache" },
  });

  if (!response.ok) {
    throw new Error(`Build metadata request failed: ${response.status}`);
  }

  return response.json();
};

export const checkForFreshBuild = async ({ forceReload = false } = {}) => {
  if (refreshInProgress || !isSafeReloadPath()) return;
  refreshInProgress = true;

  try {
    const metadata = await fetchBuildMetadata();
    const latestBuildId = metadata?.buildId || metadata?.version;
    if (!latestBuildId) return;

    const currentBuildId = window.localStorage.getItem(BUILD_ID_STORAGE_KEY);
    window.__HARDAY_BUILD_ID__ = latestBuildId;

    if (currentBuildId && currentBuildId !== latestBuildId) {
      await clearBrowserManagedCaches();
      window.localStorage.setItem(BUILD_ID_STORAGE_KEY, latestBuildId);
      if (forceReload || document.visibilityState === "visible") {
        window.location.replace(`${window.location.pathname}${window.location.search}${window.location.hash}`);
      }
      return;
    }

    if (!currentBuildId) {
      window.localStorage.setItem(BUILD_ID_STORAGE_KEY, latestBuildId);
    }
  } catch (error) {
    console.warn("Harday build refresh check failed", error);
  } finally {
    refreshInProgress = false;
  }
};

export const installBuildRefreshHandlers = () => {
  checkForFreshBuild();

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      checkForFreshBuild({ forceReload: true });
    }
  });

  window.addEventListener("focus", () => checkForFreshBuild({ forceReload: true }));
};
